import Vue from 'vue'
import VueDaterangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'

Vue.component('VueDaterangePicker', VueDaterangePicker)
